import { render } from "./Ingreso.vue?vue&type=template&id=4e59aeca"
import script from "./Ingreso.vue?vue&type=script&lang=js"
export * from "./Ingreso.vue?vue&type=script&lang=js"

import "./Ingreso.vue?vue&type=style&index=0&id=4e59aeca&lang=css"

import exportComponent from "/home/jean/web/lienzo/anden_dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__